export enum LvfAssignmentPeriodType {
  Temporary = 0,       // Temporaire
  Permanent = 1,       // Pérenne
  LongTerm = 2         // Long terme
}
